import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as OilBlockActions from './oil-block.actions';
import { OilBlockService } from '../../services/oil-block.service';

@Injectable()
export class OilBlockEffects {
  loadOilBlock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilBlockActions.loadOilBlock),
      exhaustMap((_) =>
        this.oilBlockService.getOilBlock().pipe(
          map((data) =>
            OilBlockActions.loadOilBlockSuccess({ oilBlock: data })
          ),
          catchError((error) =>
            of(OilBlockActions.loadOilBlockFailure({ error }))
          )
        )
      )
    )
  );

  addOilBlock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilBlockActions.addOilBlock),
      concatMap(({ newOilBlock }) =>
        this.oilBlockService.createOilBlock(newOilBlock).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return OilBlockActions.addOilBlockSuccess({
              newOilBlock: data,
            });
          }),
          catchError((error) =>
            of(
              OilBlockActions.addOilBlockFailure({ error: error.error.message })
            )
          )
        )
      )
    )
  );

  updateOilBlock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilBlockActions.updateOilBlock),
      map((action) => action.updateOilBlock),
      concatMap((updateOilBlock) =>
        this.oilBlockService.updateOilBlock(updateOilBlock).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return OilBlockActions.updateOilBlockSuccess({
              updateOilBlock: updateOilBlock,
            });
          }),
          catchError((error) =>
            of(OilBlockActions.updateOilBlockFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeOilBlock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilBlockActions.removeOilBlock),
      map((action) => action.ids),
      concatMap((ids) =>
        this.oilBlockService.deleteOilBlock(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return OilBlockActions.removeOilBlockSuccess({ ids });
          }),
          catchError((error) =>
            of(OilBlockActions.updateOilBlockFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private oilBlockService: OilBlockService,
    private notification: NotificationService
  ) {}
}
